export const print_btn_action = {
    print: { title: "출력", click: "print" },
    pdf: { title: "PDF", click: "pdf" },
    excel: { title: "엑셀", click: "excel" },
};
export const pdf_and_print = [
    print_btn_action.print,
    print_btn_action.pdf,
];
export const pdf_and_excel = [
    print_btn_action.print,
    print_btn_action.pdf,
    print_btn_action.excel,
];
